function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 25.5,
  r: 25.5,
  fill: "#F9C646"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_107_200)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.5 36C22.7152 36 20.0445 34.8938 18.0754 32.9246C16.1062 30.9555 15 28.2848 15 25.5C15 22.7152 16.1062 20.0445 18.0754 18.0754C20.0445 16.1062 22.7152 15 25.5 15C28.2848 15 30.9555 16.1062 32.9246 18.0754C34.8938 20.0445 36 22.7152 36 25.5C36 28.2848 34.8938 30.9555 32.9246 32.9246C30.9555 34.8938 28.2848 36 25.5 36ZM25.5 33.9C27.7278 33.9 29.8644 33.015 31.4397 31.4397C33.015 29.8644 33.9 27.7278 33.9 25.5C33.9 23.2722 33.015 21.1356 31.4397 19.5603C29.8644 17.985 27.7278 17.1 25.5 17.1C23.2722 17.1 21.1356 17.985 19.5603 19.5603C17.985 21.1356 17.1 23.2722 17.1 25.5C17.1 27.7278 17.985 29.8644 19.5603 31.4397C21.1356 33.015 23.2722 33.9 25.5 33.9ZM24.45 25.9305V19.2H26.55V25.0695L30.6975 29.217L29.217 30.6975L24.45 25.9305Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_107_200"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 21,
  fill: "white",
  transform: "translate(15 15)"
})));

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.d93c145f9b844ea68552c0a634b69cdb.svg";
export { ForwardRef as ReactComponent };